import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Logo, Typography } from '@guildeducationinc/recess';
import { useCurrentClient } from '@src/hooks/useCurrentClient';
import { useGetS3Url } from 'pe-core-frontend';
import styles from '../LoginForm/LoginForm.module.scss';
export const ClientHeader = () => {
    const { currentClient } = useCurrentClient();
    const { s3Url: logoUrl } = useGetS3Url({ s3Key: currentClient?.logoS3Key });
    return (_jsxs("div", { className: styles.clientHeader, children: [_jsxs("div", { className: 'flex gap-8 items-center', children: [_jsx(Logo, { fullLogo: true, alt: 'Guild Education' }), logoUrl && _jsx("img", { className: styles.logo, src: logoUrl, alt: currentClient?.name || 'Employer logo' })] }), _jsx(Typography, { variant: 'label1', children: currentClient?.name })] }));
};
